import { base } from '@/vuex-extend';
import extend from '@/utils/vuex-extend';
import { wait } from '@/utils/wait';
import { fetchTreeList } from '@/api/menu';

export default extend(base, {
    namespaced: true,

    state: {
        menuTreeList: []
    },

    actions: {
        async fetchTreeList({ dispatch, commit }) {
            await wait(dispatch, 'ums.role.allocMenu.fetchTreeList', async function() {
                const response = await fetchTreeList();
                commit('save', {
                    menuTreeList: response.data
                })
            })
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/modules/ums/role/alloc-menu.js